export function toCapsSnakeCase(str: string): string {
  const pascalCaseStr = toPascalCase(str);
  return pascalCaseStr.replace(/([a-z])([A-Z])/g, "$1_$2").toUpperCase();
}

export function toSentenceCase(input: string): string {
  // Convert camelCase to space-separated words, ensuring consecutive capitals remain untouched
  input = toCamelCase(input);
  const result = input
    .replace(/([a-z\d])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .trim();

  // Capitalize the first letter of the result if the whole word isn't in uppercase
  return result
    .split(" ")
    .map((word) =>
      word.toUpperCase() === word
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    )
    .join(" ");
}

export function toKebabCase(str: string): string {
  const pascalCaseStr = toCamelCase(str);

  //First letter should always be lowercase in for kebab case
  const noPrefixDashResult = pascalCaseStr.replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();

  return noPrefixDashResult;
}

export const toCamelCase = (str: string) => {
  const pascalStr = toPascalCase(str);
  /**
     * "nameCml": "eND",
        "namePscl": "END",
        "nameKbb": "e-nd",
        Handle the above edge case by finding the leading caps letters
        if all caps can make all lower
        If not all caps lower until the last one
     */
  const prefixUpperCaseMatch = pascalStr.match(/^[A-Z]*/);
  const numPrefixUpperCaseLetters = prefixUpperCaseMatch ? prefixUpperCaseMatch[0].length : 0;
  //Need to make at least first letter lowercase
  const numCharsToLowerCase = Math.max(
    1,
    numPrefixUpperCaseLetters === pascalStr.length
      ? numPrefixUpperCaseLetters
      : numPrefixUpperCaseLetters - 1,
  );
  const result = lowercaseFirstXLetters(pascalStr, numCharsToLowerCase);
  return result;
};

//TODO: Make pascal case not remove leading numbers, but put checks in all dependent functions such that vairable names do not start with leading numbers
export function toPascalCase(string: string): string {
  let result;
  //TODO: Test case for spaces at end of string edge case
  result = string.replace(/^[^a-zA-Z0-9]+|[^a-zA-Z0-9]+/g, " ");
  result = result.replace(/[^\w\s]/g, "");
  result = result.replace(/\s+(.)(\w*)/g, ($1, $2, $3) => $2.toUpperCase() + $3.toLowerCase());
  result = result.replace(/\w/, (s) => s.toUpperCase());
  result = result.trim();
  return result;
}

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function lowercaseFirstLetter(string: string) {
  return string.charAt(0).toLowerCase() + string.slice(1);
}

function lowercaseFirstXLetters(str: string, x: number) {
  return str.slice(0, x).toLowerCase() + str.slice(x);
}
